import { useTranslation } from "react-i18next";
import { Row, Col, Card, CardBody } from "react-bootstrap";
import crudApi from "@serie3/common/api/crudApi";
import { useEffect, useState } from "react";
import MessagesEndpoints from "@serie3/mymediaplanner/Modules/Messages/endpoints";
import AddButton from "../../../shared/Buttons/AddButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faCircle,
  faEdit,
  faTrash,
  faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";
import NewModal from "../../../shared/Modals/NewModal";
import MessageForm from "@serie3/mymediaplanner/Modules/Messages/Forms/MessageForm";
import SaveButton from "../../../shared/Buttons/SaveButton";
import { useFormik } from "formik";
import Message from "@serie3/mymediaplanner/Modules/Messages/Entity/Message";
import TextArea from "../../../Form/TextArea";
import TextField from "../../../Form/TextField";
import listHandler from "@serie3/common/Domain/listHandler";
import ToastMessages from "../../../../ToastMessages";

const Messages = () => {
  const { t } = useTranslation();
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showEdit, setShowEdit] = useState(false);
  const [editMessage, setEditMessage] = useState();

  const AddBtn = () => {
    return (
      <>
        <AddButton
          addFunction={() => {
            setEditMessage(null);
            setShowEdit(true);
          }}
        />
      </>
    );
  };

  useEffect(() => {
    const fetchMessags = async () => {
      await crudApi.getAll(MessagesEndpoints.index, setMessages, "messages");
      setLoading(false);
    };
    fetchMessags();
  }, []);

  const editMessageForm = MessageForm.createMessageForm(
    messages,
    setMessages,
    setShowEdit
  );

  const formik = useFormik(editMessageForm);

  const Save = () => {
    return (
      <>
        <SaveButton
          submitFunction={(e) => {
            formik.handleSubmit(e);
            e.preventDefault();
          }}
        />
      </>
    );
  };

  const setActive = async (item) => {
    const response = await crudApi.justGet(
      MessagesEndpoints.setActive + item.id
    );
    if (response.ok) {
      listHandler.replaceItemInList(response.data, messages, setMessages);

      for (const message of messages) {
        if (message.id !== item.id) {
          try {
            if (message.active) {
              const response = await crudApi.justGet(
                MessagesEndpoints.setActive + message.id
              );
              listHandler.replaceItemInList(
                response.data,
                messages,
                setMessages
              );
            }
          } catch (error) {
            console.error("Error fetching message:", error);
          }
        }
      }

      ToastMessages.SuccessfulSave("Active message changed");
    }
  };

  return (
    <>
      <NewModal
        show={showEdit}
        setShow={setShowEdit}
        title={formik.values.title}
        ExtraButton={Save}
        onShow={() => {
          editMessage
            ? formik.setValues(MessageForm.setEditData(editMessage))
            : formik.setValues(Message);
        }}
        onExit={() => {
          formik.resetForm({ values: { Message } });
        }}
      >
        <Row>
          <Col>
            <TextField
              formik={formik}
              label={t("Backend.Post.Title")}
              valueName={"title"}
              style={{ marginBottom: "10px" }}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <TextArea
              formik={formik}
              label=" "
              valueName={"text"}
              style={{ marginBottom: "10px" }}
              rows={10}
            />
          </Col>
        </Row>
        <Row>
          <Col className="mt-3">
            <b>HINT:</b> Use {"{{firstname}}"} a placeholder for the first name
            of your contact. No other placeholders are available right now!
          </Col>
        </Row>
      </NewModal>
      <h4 className="page-section-header">
        <span className="page-section-header-icon" style={{ background: "rgba(3,142,220,0.12)" }}>
          <FontAwesomeIcon icon={faPaperPlane} style={{ color: "#038edc" }} />
        </span>
        {t("Backend.Outreach.Messages.Messages")}
      </h4>
      <Card>
        <CardBody>
          <Row>
            <Col>
              <div className="page-title-box d-flex align-items-center justify-content-end">
                <AddBtn />
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              {loading ? (
                <div style={{ padding: "8px 0" }}>
                  {[1, 2, 3].map((i) => (
                    <div key={i} style={{ display: "flex", gap: 12, alignItems: "center", padding: "12px 0", borderBottom: "1px solid #f3f4f6" }}>
                      <div className="skeleton" style={{ width: 30, height: 14 }} />
                      <div className="skeleton" style={{ width: 120, height: 14 }} />
                      <div className="skeleton" style={{ flex: 1, height: 14 }} />
                      <div className="skeleton" style={{ width: 70, height: 28, borderRadius: 20 }} />
                      <div className="skeleton" style={{ width: 60, height: 28, borderRadius: 8 }} />
                    </div>
                  ))}
                </div>
              ) : (
              <div className="table-responsive">
                <table className="data-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Title</th>
                      <th>Message</th>
                      <th style={{ textAlign: "center" }}>Active</th>
                      <th style={{ textAlign: "right" }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {messages.map((item, index) => (
                      <tr key={index}>
                        <td style={{ color: "#9299a8", width: 40 }}>#{index + 1}</td>
                        <td style={{ fontWeight: 600, color: "#111827" }}>{item.title}</td>
                        <td style={{ color: "#6b7280", maxWidth: 320, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{item.text}</td>
                        <td style={{ textAlign: "center" }}>
                          <button
                            type="button"
                            onClick={() => setActive(item)}
                            style={{
                              padding: "4px 12px", borderRadius: 20, cursor: "pointer",
                              border: `1.5px solid ${item.active ? "#51d28c" : "#eaecf0"}`,
                              background: item.active ? "rgba(81,210,140,0.1)" : "transparent",
                              color: item.active ? "#2e9e65" : "#9299a8",
                              fontSize: 12, fontWeight: 600,
                              display: "inline-flex", alignItems: "center", gap: 5,
                            }}
                          >
                            <FontAwesomeIcon icon={item.active ? faCheck : faCircle} style={{ fontSize: 10 }} />
                            {item.active ? "Active" : "Inactive"}
                          </button>
                        </td>
                        <td style={{ textAlign: "right", whiteSpace: "nowrap" }}>
                          <button type="button" className="tbl-action-btn" onClick={() => { setEditMessage(item); setShowEdit(true); }}>
                            <FontAwesomeIcon icon={faEdit} />
                          </button>
                          <button type="button" className="tbl-action-btn danger" onClick={() => listHandler.deleteFromList(index, crudApi.del(MessagesEndpoints.delete, item.id), setMessages, messages)}>
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              )}
            </Col>
          </Row>
        </CardBody>
      </Card>
    </>
  );
};

export default Messages;
